function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4d90"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4d90"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $ed2a84f278ba0e5e$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"Y15zO":"index.1d9ac4af.js","3mOG6":"logo.92272af7.png","3jDP9":"home.928e4a8a.png","3bjLz":"restaurant.7926c2f5.png","5pMzR":"grocery-store.06990304.png","da9JR":"enter.df9f8f1a.png","bWQDg":"logout.0ea036cc.png","jtIZZ":"help.0491a8ac.png","1mhd7":"mart.55862b9a.png","2oFKc":"No-data-error.2fca8d46.png","6GqSe":"error-page.8b723d28.jpg","jqJgU":"Foodimage1.6b7e94a7.jpg","a5xNl":"Foodimage2.d4ca8b14.jpg","9ZRN7":"Foodimage3.adfa2020.jpg","fG9W2":"carousel-item2.72bbe627.jpg","jP4JR":"cuisine.e2d4610a.png","5Fvrj":"location.944d767f.png","4ekta":"star.17df0c10.png","7RBjC":"empty-cart.d347bb66.jpg","5W9PP":"FoodMartComponent.072686ef.js","03H1O":"Food-Mart.c185d2f6.png"}'));


//# sourceMappingURL=index.2ca11f95.js.map
